import React from 'react'
import PropTypes from 'prop-types'

const StarRating = ({
    rating,
    className,
    fullStarClass = 'star-rating__star--full',
    halfStarClass = 'star-rating__star--half',
    emptyStarClass = 'star-rating__star--empty',
    maxStars = 5
}) => {
  let stars = []
  let roundedRating = Math.round(rating * 2) / 2.0
  for (let i = 0; i < Math.floor(roundedRating); i++) {
    stars.push(fullStarClass)
  }

  if (roundedRating % 1) {
    stars.push(halfStarClass)
  }

  while (stars.length < maxStars) {
    stars.push(emptyStarClass)
  }

  return (
    <div className={className}>
      {stars.map((starClass, index) => {
        return <b key={index} className={starClass} />
      })}
    </div>
  )
}

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  className: PropTypes.string,
  fullStarClass: PropTypes.string,
  halfStarClass: PropTypes.string,
  emptyStarClass: PropTypes.string,
  maxStars: PropTypes.number
}

export default StarRating



// WEBPACK FOOTER //
// ./client/pages/search/result/starRating.js